import IRoutes from "../interfaces/IRoutes";
import LogEvents from "../pages/logEvents/LogEvents";

const LogEventsRoute: Array<IRoutes> = [
    {
        element: <LogEvents />,
        path: "/event-log",
    }
];

export { LogEventsRoute };
